export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, (txt: string) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

// https://github.com/intesso/decode-html/tree/9942b1064105d59d767d5527c4b1a1c56cad1946
export const decodeHtml = (text: string) => {
  const entities = {
    amp: "&",
    apos: "'",
    lt: "<",
    gt: ">",
    quot: '"',
    nbsp: "\xa0"
  };
  const entityPattern = /&([a-z]+);/gi;

  return (text || "").replace(entityPattern, (match, entity) => {
    entity = entity.toLowerCase();
    if (entities.hasOwnProperty(entity)) {
      return entities[entity];
    }
    return match;
  });
};

export const camelCaseToSentenceCase = (text: string): string => {
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const toCamelCase = (str: string) => {
  return str
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .split(" ")
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("");
};

export const ObjectToArray = (obj: object): any[] => Object.values(obj);



// WEBPACK FOOTER //
// ./src/helpers.ts